import investDevelopment from '../../../assets/site/invest-development.jpg';
import investValueAdd from '../../../assets/site/invest-value-add.jpg';
import investPartnered from '../../../assets/site/invest-partnered.jpg';
import avatarMauricio from '../../../assets/site/avatar-mauricio.jpg';
import avatarKetan from '../../../assets/site/avatar-ketan.jpg';
import insightPurpose from '../../../assets/site/insight-purpose.jpg';
import insightEb5 from '../../../assets/site/insight-eb5.jpg';
import insightExits from '../../../assets/site/insight-exits.jpg';

export const missionStatement =
  'To build lasting wealth for our investors by rebuilding the neighborhoods and cities that need it most, one well-chosen property at a time.';

export const missionValues = [
  {
    title: 'Investor first',
    text: 'Every opportunity is evaluated through one lens: is it right for the people who trust us with their capital?',
  },
  {
    title: 'Community impact',
    text: 'We invest where good buildings can change a block, a neighborhood and a local economy.',
  },
  {
    title: 'Clear and honest',
    text: 'Plain-language communication at every stage, from first conversation to final return.',
  },
];

export const investmentOptions = [
  {
    title: 'Development projects',
    text: 'Ground-up and adaptive-reuse residential and mixed-use projects in cities ready to grow.',
    image: investDevelopment,
  },
  {
    title: 'Value-add acquisitions',
    text: 'Under-managed buildings repositioned through renovation, leasing and better operations.',
    image: investValueAdd,
  },
  {
    title: 'Partnered investment',
    text: 'Invest alongside DS360 with aligned interests and clear reporting throughout.',
    image: investPartnered,
  },
];

export const processSteps = [
  {
    title: 'Talk with us',
    text: 'Schedule a call. We learn your goals, timeline and comfort with risk.',
  },
  {
    title: 'Choose your investment',
    text: 'We walk you through the opportunities that fit and the details behind each one.',
  },
  {
    title: 'Grow and rebuild',
    text: 'Your capital goes to work while we manage the project and keep you informed.',
  },
];

export const testimonials = [
  {
    quote:
      'I recently invested with DS360, and the entire experience exceeded my expectations. Throughout the investment period, I felt completely secure and confident in their management. True to their word, the funds were paid back promptly and precisely on the agreed-upon terms. Their professionalism, transparency, and reliability make them an outstanding partner for investment. I look forward to working with DS360 again and highly recommend them to anyone seeking a dependable financial partner.',
    name: 'Mauricio C.',
    role: 'DS360 investor',
    avatar: avatarMauricio,
  },
  {
    quote:
      'My experience with Sammy has been very positive, and I appreciate the professionalism and confidence they bring to the investment process. I am already invested in other projects and am always looking to build relationships with trustworthy partners who share a long-term vision. I value transparency, reliability, and clear communication, and Sammy has delivered in all fronts. I look forward to continuing to work together and exploring future investment opportunities. I would recommend Sammy to anyone looking to establish a strong, long-term investment partnership.',
    name: 'Ketan K.',
    role: 'DS360 investor',
    avatar: avatarKetan,
  },
];

export const insights = [
  {
    tag: 'Market notes',
    title: 'Wealth-building with purpose',
    text: 'Explore comprehensive wealth-building strategies that combine real estate investment with community development and social impact initiatives for sustainable growth.',
    image: insightPurpose,
    href: 'https://gamma.app/docs/Building-Wealth-with-Purpose-DS-360-Investment-z5oetrol2zu7z0m?mode=doc',
  },
  {
    tag: 'Strategy',
    title: 'Inside our Newark EB-5 opportunity',
    text: 'Discover an exceptional EB-5 investment opportunity in Newark, NJ. 165-unit residential development with 10% projected ROI in 12 months and TEA qualification for reduced investment threshold.',
    image: insightEb5,
    href: 'https://gamma.app/docs/EB-5-Investment-Opportunity-Newark-Residential-Development-jqrh7j46v054z1l',
  },
  {
    tag: 'Investor guide',
    title: 'Strategic exit planning, built in',
    text: 'Learn about DS360’s strategic exit planning for real estate investments. Access exclusive off-market opportunities with pre-planned exit strategies.',
    image: insightExits,
    href: 'https://ds360-investments-your-g-t78gsqy.gamma.site/',
  },
];

export const footerColumns = [
  {
    title: 'Education',
    links: [
      { label: 'Foreclosure Guide', to: '/foreclosure-guide' },
      { label: 'Investment Basics', to: '/investment-basics' },
      {
        label: 'Market Analysis',
        href: 'https://gamma.app/docs/New-Jersey-Real-Estate-Market-Analysis-f25ggs8gunle6k0?mode=doc',
      },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About DS360', to: '/about' },
      { label: 'FAQs', to: '/faq' },
      { label: 'Privacy Policy', to: '/privacy-policy' },
    ],
  },
];

export const disclosure =
  'DS360 is a registered trademark. All rights reserved. The Platform does not provide investment, legal or tax advice. These investments are intended for accredited investors who understand and accept the high degree of risk associated with private investments.';
